/**
 * @param selector
 * @param value
 */
function setDisplay(selector, value) {
    const elements = document.querySelectorAll(selector);
    elements.forEach((element) => {
        element.style.display = value;
    });
}
/**
 * Sets display:none on elements matching the selector.
 *
 * @param selector CSS selector to set.
 */
export function hide(selector) {
    setDisplay(selector, "none");
}
/**
 * Sets display:block on elements matching the selector.
 *
 * @param selector CSS selector to set.
 * @param display
 */
export function show(selector, display) {
    setDisplay(selector, display !== null && display !== void 0 ? display : "block");
}
